export const REPORT_STATUS_ID_ENABLED = 1
export const REPORT_STATUS_ID_DISABLED = 2
export const REPORT_STATUS_ID_DELETE = 3
export const REPORT_ITEM_STATUS_ID_ENABLED = 1
export const REPORT_ITEM_STATUS_ID_DISABLED = 2
export const REPORT_TRIGGER_STATUS_ID_ENABLED = 1
export const REPORT_TRIGGER_STATUS_ID_DISABLED = 5

export const ReportExportXLSX = 1
export const ReportExportEmail = 4
export const ReportExportTypeIDs = [ReportExportXLSX, ReportExportEmail]